<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="10">
            <a-form-item label="项目名称">
              <j-dict-select-tag
                placeholder="请输入项目名称"
                v-model="queryParam.project"
                dictCode="bms_project">
              </j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="期数">
              <a-input placeholder="请录入期数" v-model.trim="queryParam.period"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <a-form-item label="开票编码">
              <a-input v-model.trim="queryParam.invoiceNumber" placeholder="请输入开票编码"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <a-form-item label="状态" >
              <j-dict-select-tag
                placeholder="请选择状态"
                v-model="queryParam.status"
                dictCode="bms_invoice_status">
              </j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <a-form-item label="申请人" >
              <j-search-select-tag
                placeholder="请选择申请人姓名"
                v-model="queryParam.user"
                dict="sys_user,realname,username,del_flag=0">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="推送日期">
              <a-range-picker
                v-model="queryParam.inputDateRange"
                format="YYYY-MM-DD"
                :placeholder="['开始日期', '结束日期']"
                @change="onDateChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!--<div class="table-operator">-->
      <!--<a-button type="primary" icon="download" @click="handleExportXls('发票推送表')" >导出</a-button>-->
    <!--</div>-->

      <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        <a v-if="selectionRows.length>=2 && selectionRows.every(r => r.status == 0)" style="margin-left: 24px" @click="mergeInvoice">合并发票</a>
        <span style="float:right;margin-right: 24px" >金额单位：元</span>
        <span style="float:right;margin-right: 24px" >价税合计总额：{{sumPriceTaxTotal}}</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
          <a-divider type="vertical" v-if="record.status==0" v-has="'invoiceinfoSend:edit'"/>
          <a v-if="record.status==0" @click="handleEdit(record)" v-has="'invoiceinfoSend:edit'">编辑</a>
          <a-divider type="vertical" v-if="record.status==0" v-has="'invoiceinfoSend:send'"/>
          <a v-if="record.status==0" @click="handleSend(record)" v-has="'invoiceinfoSend:send'">推送</a>
        </span>

      </a-table>
    </div>

    <biz-invoiceinfo-modal ref="modalForm" @ok="modalFormOk" :editScene="editScene"></biz-invoiceinfo-modal>
  </a-card>
</template>

<script>
  import { getAction, postAction} from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util';
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import BizInvoiceinfoModal from '../invoice/modules/BizInvoiceinfoModal'
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'BizInvoiceinfoSendList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      BizInvoiceinfoModal,
      JSearchSelectTag
    },
    props: {
      queryParams: {
        type: Object,
        default: () => {}
      },
      editScene: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        description: '发票推送页面',
        disableMixinCreated: true,
        sumPriceTaxTotal: 0.00, // 价税合计
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'开票编码',
            align:"center",
            dataIndex: 'invoiceNumber',
            sorter: true,
          },
          {
            title:'状态',
            align:"center",
            dataIndex: 'status_dictText'
          },
          {
            title:'期数',
            align:"center",
            dataIndex: 'period'
          },
/*          {
            title:'票内/票外',
            className:"column-text",
            sorter: true,
            dataIndex: 'insideOrOutside_dictText'
          },/!*V9*!/*/
          {
            title:'申请人',
            align:"center",
            dataIndex: 'user_dictText',
            sorter: true
          },
          {
            title:'申请人部门',
            className:"column-text",
            dataIndex: 'userDep_dictText',
            sorter: true
          },
          {
            title:'项目名称',
            className:"column-text",
            dataIndex: 'project_dictText'
          },
          {
            title:'业务类型',
            align:"center",
            dataIndex: 'businessType_dictText'
          },
          {
            title:'佣金计算方式',
            align:"center",
            dataIndex: 'brokerageWay_dictText'
          },
          {
            title:'经纪人',
            align:"center",
            sorter: true,
            dataIndex: 'broker_dictText'
          },
          {
            title:'部门',
            className:"column-text",
            sorter: true,
            dataIndex: 'insuranceDep_dictText'
          },
          {
            title:'发票类型',
            align:"center",
            dataIndex: 'invoiceType_dictText'
          },
          {
            title:'购买方名称',
            className:"column-text",
            dataIndex: 'consumerName'
          },
          {
            title:'购买方纳税人识别号',
            className:"column-text",
            dataIndex: 'consumerIdentification'
          },
          {
            title:'购买方地址',
            className:"column-text",
            dataIndex: 'consumerAddress'
          },
          {
            title:'购买方电话',
            className:"column-text",
            dataIndex: 'consumerPhone'
          },
          {
            title:'购买方开户行',
            className:"column-text",
            dataIndex: 'consumerBankName'
          },
          {
            title:'购买方开户行账号',
            className:"column-text",
            dataIndex: 'consumerBankNumber'
          },
          {
            title:'发票开具内容',
            className:"column-text",
            dataIndex: 'invoiceContent_dictText'
          },
          {
            title:'保费',
            className:'column-money',
            dataIndex: 'rate',
            customRender:function (text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          {
            title:'净保费',
            className:'column-money',
            dataIndex: 'cleanPremium',
            customRender:function (text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          {
            title:'金额',
            className:'column-money',
            dataIndex: 'money',
            customRender:function (text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          {
            title:'税额',
            className:'column-money',
            dataIndex: 'tax',
            customRender:function (text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          {
            title:'价税合计',
            className:'column-money',
            dataIndex: 'sumPriceTax',
            customRender:function (text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          {
            title:'开票单位', //九安、 九安分公司
            className:"column-text",
            dataIndex: 'invoiceUnit_dictText',
          },
          {
            title:'推送日期',
            align:"center",
            dataIndex: 'sendTime'
          },
          {
            title:'备注',
            className:"column-text",
            dataIndex: 'ps'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:130,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/bms/bizInvoiceinfo/list",
          send: "/bms/bizInvoiceinfo/send", // 推送开票
          exportXlsUrl: "/bms/bizInvoiceinfo/exportXls",
          getMoneyTotal: '/bms/bizInvoiceinfo/getMoneyTotal',
          mergeInvoice: '/bms/bizInvoiceinfo/mergeInvoice',
        },
        dictOptions:{},
      }
    },
    created() {
      // 业务管理入口只查当前用户自己的数据
      if (this.editScene === 'directinvoice') {
        this.url.list = '/bms/bizInvoiceinfo/listForBiz'
      }
      // 应用外部传入的查询参数
      if (this.queryParams) {
        if (this.queryParams.inputDateRange) {
          this.queryParam.inputDateRange = this.queryParams.inputDateRange
        }
        if (this.queryParams.status) {
          this.queryParam.status = this.queryParams.status
        }
        if (this.queryParams.inputDateRange || this.queryParams.status) {
          this.loadData(1)
        }
      }
    },
    watch: {
      queryParams: {
        handler(newVal) {
          if (newVal) {
            if (newVal.inputDateRange) {
              this.queryParam.inputDateRange = newVal.inputDateRange
            }
            if (newVal.status) {
              this.queryParam.status = newVal.status
            }
            if (newVal.inputDateRange || newVal.status) {
              this.loadData(1)
            }
          }
        },
        deep: true
      }
    },
    computed: {
    },
    methods: {
      initDictConfig(){
      },
      getQueryParams() {
        var param = Object.assign({}, this.queryParam, this.isorter ,this.filters)
        if(param.invoiceNumber){
          param.invoiceNumber = `*${param.invoiceNumber}*` // 开票编码模糊匹配
        }
        if(param.inputDateRange != undefined && param.inputDateRange.length === 2){
          param.sendTime_begin = this.queryParam.inputDateRange[0] + ' 00:00:00';
          param.sendTime_end = this.queryParam.inputDateRange[1] + ' 23:59:59';
          delete param.inputDateRange;
        }
        //param.field = this.getQueryField()
        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
        // 发票推送/开票推送均全查票内票外：/list 与 listForBiz 后端不读 extraParam，此处不再下传（原 extraParam='0' 为不生效的死参数，易误导）
        return filterObj(param);
      },
      loadData(arg) {
        if (arg == 1) {
          this.ipagination.current = 1
        }
        let params = this.getQueryParams();
        this.loading = true
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
            // 查询总合计金额,只查询一次
            if(this.ipagination.current === 1){
              getAction(this.url.getMoneyTotal, params).then((result)=>{
                if (result.success) {
                  this.sumPriceTaxTotal = !result.result ? '0.00' : result.result.toLocaleString();
                }
              })
            }
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      //推送
      handleSend(record){
        if(record == null || record == undefined){
          return;
        }
        let params = {
          id: record.id
        }
        let that = this;
        postAction(this.url.send, params).then((res) => {
          if(res.success && res.result){
            this.$message.info("推送开票信息成功")
            this.loadData();
          } else{
            this.$message.warning(res.message)
          }
        })
      },
      onDateChange: function (value, dateString) {
        this.queryParam.inputDateRange = dateString;
      },

      // 合并发票
      mergeInvoice(){
        //至少选择两条发票，支持多张发票合并，但要符合合并条件
        if(this.selectionRows.length<2){
          this.$message.warning("至少选择两条发票")
          return
        }
        const INVOICE_STATUS_NOT_SEND = '0';
        let ids = [];
        let selectedRow1 = this.selectionRows[0];
        ids.push(selectedRow1.id)

        if(selectedRow1.status != INVOICE_STATUS_NOT_SEND){
          this.$message.warning("发票状态必须是未推送")
          return
        }

        for(let i=1; i<this.selectionRows.length;i++){
          let selectedRow2 = this.selectionRows[i]
          ids.push(selectedRow2.id)
          if(selectedRow1.status != selectedRow2.status){
            this.$message.warning("选择的第" + (i+1) + "条数据发票状态不是未推送")
            return
          }
          if(selectedRow1.project != selectedRow2.project){
            this.$message.warning("选择的第" + (i+1) + "条发票与第1条项目不同")
            return
          }
          if(selectedRow1.invoiceType != selectedRow2.invoiceType ){
            this.$message.warning("选择的第" + (i+1) + "条发票与第1条发票类型不同")
            return
          }
          if(selectedRow1.businessType != selectedRow2.businessType){
            this.$message.warning("选择的第" + (i+1) + "条发票与第1条业务类型不同")
            return
          }
          if( selectedRow1.brokerageWay != selectedRow2.brokerageWay){
            this.$message.warning("选择的第" + (i+1) + "条发票与第1条佣金计算方式不同")
            return
          }
          if(selectedRow1.broker != selectedRow2.broker){
            this.$message.warning("选择的第" + (i+1) + "条发票与第1条经纪人不同")
            return
          }
          if(selectedRow1.companyCode != selectedRow2.companyCode) {
            this.$message.warning("选择的第" + (i+1) + "条发票与第1条购买方不同")
            return
          }
          if(selectedRow1.invoiceUnit != selectedRow2.invoiceUnit){
            this.$message.warning("选择的第" + (i+1) + "条发票与第1条开票单位不同")
            return
          }
          if(selectedRow1.insideOrOutside != selectedRow2.insideOrOutside) {
            this.$message.warning("选择的第" + (i+1) + "条发票与第1条票内/票外类型不同")//V13
            // this.$message.warning("选择的第" + (i+1) + "条发票与第1条票内类型不同")
            return
          }
        }
        
        postAction(this.url.mergeInvoice, ids).then( res =>{
          if(res.success){
            this.$message.info("合并发票成功")
            this.onClearSelected()
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        })

      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>